import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import StylePropType from 'react-style-proptype';
import PropTypes from 'prop-types';
import Styles from './JumperScrollbar.styles';

class JumperScrollbar extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);
    this.state = { top: 0 };
    this.renderThumb = this.renderThumb.bind(this);
  }

  renderThumb({ style, ...props }) {
    return <div style={{ ...style, ...Styles.thumbStyle, ...this.props.thumbStyle }} {...props} />;
  }

  renderView({ style, ...props }) {
    const tempStyle = {
      paddingRight: '10px',
      ...this.props.viewStyle,
    };
    return <div className="box" style={{ ...style, ...tempStyle }} {...props} />;
  }

  render() {
    return (
      <Scrollbars
        renderView={props => this.renderView(props)}
        renderThumbVertical={this.renderThumb}
        renderTrackVertical={props => (
          <div {...props} style={Styles.verticalBar}>
            {props.children}
          </div>
        )}
      >
        {this.props.children}
      </Scrollbars>
    );
  }
}
JumperScrollbar.defaultProps = {
  viewStyle: {},
  thumbStyle: {},
  children: {},
};

JumperScrollbar.propTypes = {
  viewStyle: StylePropType,
  thumbStyle: StylePropType,
  children: PropTypes.node,
};

export default JumperScrollbar;



// WEBPACK FOOTER //
// ./src/components/JumperScrollbar/JumperScrollbar.js